<div class="ap-recipients">
    <div class="ap-recipients-header">
        <p class="ap-section-label">
            {{ section.label }}
            <span class="ap-recipients-count">· {{ activeCount() }} units</span>
        </p>
    </div>

    <!-- V2 unit selector IS the recipient list. Existing units come back
         pre-checked; the user checks / unchecks to adjust the batch.
         Max-height capped so this never takes over the chat — internal
         scrolling handles bigger orgs. -->
    <div class="ap-recipients-picker">
        <app-v2-unit-selector
            [selectionMode]="true"
            [preselectedUnitIds]="existingUnitIds"
            [isDisplayedInModal]="false"
            [initialFilterPanelOpen]="false"
            (onSelect)="onSelectionChange($event)">
        </app-v2-unit-selector>
    </div>
</div>
